// extracted by mini-css-extract-plugin
export default {"layout":"_5D1Qm9dR","mobile-button":"_5DLz_BoI","desktop-button":"_5D3ZN5HF","results__wrapper":"_5D16KlVW","is-visible":"_5D2AhIxE","results":"_5D34Be04","error":"_5DqS531A"};